module.exports = __webpack_public_path__ + "static/media/spoonerism-task (16).5c818465.mp3";